import { Check, Plus } from "lucide-react";
import type { CatalogueListing } from "../../api/catalogue";
import { Button, Icon } from "../../components/ui";
import { useAddToBasket } from "../cart/useCart";

/** One into the basket from a product card or a list row. Out of stock is never orderable (PRD 5.7). */
export function CardAddButton({ listing, compact = false }: { listing: Pick<CatalogueListing, "id" | "in_stock">; compact?: boolean }) {
  const basket = useAddToBasket(listing.id);
  if (!listing.in_stock) {
    return (
      <Button size="sm" fullWidth={!compact} disabled>
        Out of stock
      </Button>
    );
  }
  return (
    <span className={compact ? "inline-flex flex-col items-end" : "block"}>
      <Button size="sm" fullWidth={!compact} icon={Plus} disabled={basket.state.adding} onClick={() => basket.onAdd(1)}>
        {basket.state.adding ? "Adding…" : compact ? "Add" : "Add to basket"}
      </Button>
      {basket.state.added !== null && !basket.state.adding && (
        <span role="status" className="mt-2 flex items-center gap-1 type-small text-success-700">
          <Icon icon={Check} size={14} /> {compact ? "Added" : "Added to basket"}
        </span>
      )}
      {basket.state.error && (
        <span role="alert" className="mt-2 block type-small text-danger-700">
          {basket.state.error}
        </span>
      )}
    </span>
  );
}
